(function() {
  var FEE_PRODUCTS = {
    plaque: 'pedestal-inscription',
    tag: 'inscription-tag',
    engraving_wo: 'wooden-temple-ornament-custom-inscription',
    engraving_state: 'state-sign-engraving'
  };

  var BUNDLE_PRODUCTS = {
    'declaration-of-independence-america-the-beautiful-sign-framed-distressed-american-flag-patriotic-laser-engraved-framed-wall-art': [
      'bundled-america-the-beautiful-sign-patriotic-laser-engraved-framed-wall-art',
      'bundled-framed-distressed-american-flag-patriotic-laser-engraved-framed-wall-art'
    ],
    'patriotic-bundle': [
      'bundled-framed-distressed-american-flag-patriotic-laser-engraved-framed-wall-art'
    ],
    'declaration-of-independence-america-the-beautiful-sign-patriotic-laser-engraved-framed-wall-art': [
      'bundled-america-the-beautiful-sign-patriotic-laser-engraved-framed-wall-art'
    ],
    'declaration-of-independence-united-states-constitution-patriotic-laser-engraved-framed-wall-art': [
      'bundled-united-states-constitution-flag-design-patriotic-laser-engraved-framed-wall-art'
    ]
  };

  var bundleVariantCache = {};

  function prefetchBundleItems(parentHandle) {
    var handles = BUNDLE_PRODUCTS[parentHandle];
    if (!handles) return;
    handles.forEach(function(handle) {
      if (bundleVariantCache[handle]) return;
      fetch('/products/' + handle + '.js')
        .then(function(r) { return r.json(); })
        .then(function(data) {
          bundleVariantCache[handle] = data.variants[0].id;
        })
        .catch(function() {});
    });
  }

  var overlay = document.getElementById('atc-popup-overlay');
  if (!overlay) return;

  var closeBtn = document.getElementById('atc-popup-close');
  var titleEl = document.getElementById('atc-popup-title');
  var imageEl = document.getElementById('atc-popup-image');
  var optionsEl = document.getElementById('atc-popup-options');
  var submitBtn = document.getElementById('atc-popup-submit');
  var messageEl = document.getElementById('atc-popup-message');

  var templeFieldEl = document.getElementById('atc-popup-temple-field');
  var templeInput = document.getElementById('atc-temple-input');

  var plaqueWrapEl = document.getElementById('atc-popup-plaque-wrap');
  var plaqueToggleLabelEl = document.getElementById('atc-plaque-toggle-label');
  var plaqueYesBtn = document.getElementById('atc-plaque-yes-btn');
  var plaqueTogglesEl = document.getElementById('atc-plaque-toggles');
  var plaqueSmallMsg = document.getElementById('atc-plaque-small-msg');
  var plaqueFieldsEl = document.getElementById('atc-popup-plaque-fields');
  var plaqueColorEl = document.getElementById('atc-plaque-color');
  var plaqueFontEl = document.getElementById('atc-plaque-font');
  var plaqueTextEl = document.getElementById('atc-plaque-text');

  var engravingWrapEl = document.getElementById('atc-popup-engraving-wrap');
  var engravingYesBtn = document.getElementById('atc-engraving-yes-btn');
  var engravingTogglesEl = document.getElementById('atc-engraving-toggles');
  var engravingFieldsEl = document.getElementById('atc-popup-engraving-fields');
  var engravingTextEl = document.getElementById('atc-engraving-text');

  var engravingFreeWrapEl = document.getElementById('atc-popup-engraving-free-wrap');
  var engravingFreeTextEl = document.getElementById('atc-engraving-free-text');

  var selectedVariantId = null;
  var currentTags = [];
  var currentFeeType = null;
  var currentProductHandle = null;
  var isSmallSelected = false;

  var feeVariantCache = {};
  var feePriceCache = {};

  function fetchFeeVariantId(feeType, callback) {
    if (feeVariantCache[feeType]) {
      callback(feeVariantCache[feeType]);
      return;
    }
    var handle = FEE_PRODUCTS[feeType];
    fetch('/products/' + handle + '.js')
      .then(function(r) { return r.json(); })
      .then(function(data) {
        var variant = data.variants[0];
        var variantId = variant.id;
        var price = (variant.price / 100).toFixed(2);
        feeVariantCache[feeType] = variantId;
        feePriceCache[feeType] = price;
        callback(variantId);
      })
      .catch(function() { callback(null); });
  }

  document.addEventListener('click', function(e) {
    var btn = e.target.closest('.js-atc-popup-open');
    if (!btn) return;

    var title = btn.dataset.productTitle;
    var image = btn.dataset.productImage;
    var defaultSong = btn.dataset.defaultSong;
    var variants = JSON.parse(btn.dataset.variants.replace(/&quot;/g, '"'));
    currentTags = btn.dataset.tags ? btn.dataset.tags.toLowerCase().split(',').map(function(t) { return t.trim(); }) : [];
    currentProductHandle = btn.dataset.productHandle || null;

    titleEl.textContent = title;
    imageEl.src = image;
    imageEl.alt = title;
    messageEl.textContent = '';
    selectedVariantId = null;
    currentFeeType = null;
    isSmallSelected = false;

    var hasPlaque = currentTags.includes('has-plaque');
    var hasTag = currentTags.includes('has-tag');
    var hasEngravingWo = currentTags.includes('has-engraving-wo');
    var hasEngravingState = currentTags.includes('has-engraving-state');
    var hasEngravingFree = currentTags.includes('has-engraving-free');
    var hasTemple = currentTags.includes('temple-selection');

    if (currentProductHandle && BUNDLE_PRODUCTS[currentProductHandle]) {
      prefetchBundleItems(currentProductHandle);
    }

    var isMusicLight = variants.some(function(v) {
      return v.title.toLowerCase().includes('families') ||
        v.title.toLowerCase().includes('spirit of god') ||
        v.title.toLowerCase().includes('come thou') ||
        v.title.toLowerCase().includes('be still');
    });

    if (isMusicLight) {
      renderVariants('Choose your song', variants, defaultSong, false);
    } else {
      var sizeLabel = variants.length === 1 ? '' : 'Choose your size';
      renderVariants(sizeLabel, variants, 'Medium', hasPlaque);
    }

    templeFieldEl.style.display = hasTemple ? 'block' : 'none';

    plaqueWrapEl.style.display = 'none';
    engravingWrapEl.style.display = 'none';
    engravingFreeWrapEl.style.display = 'none';

    resetToggle(plaqueTogglesEl);
    resetToggle(engravingTogglesEl);
    plaqueFieldsEl.style.display = 'none';
    engravingFieldsEl.style.display = 'none';
    plaqueSmallMsg.style.display = 'none';

    if (hasPlaque) {
      plaqueToggleLabelEl.textContent = 'Add a personalized plaque?';
      plaqueYesBtn.textContent = 'Yes (+$15 Added at Checkout)';
      plaqueFontEl.innerHTML = '<option value="Dancing Script">Dancing Script</option><option value="Maldina Script">Maldina Script</option><option value="Garamond">Garamond</option>';
      plaqueWrapEl.style.display = 'block';
      currentFeeType = 'plaque';
      prefetchFee('plaque');
    } else if (hasTag) {
      plaqueToggleLabelEl.textContent = 'Add a personalized tag?';
      plaqueYesBtn.textContent = 'Yes (+$11 Added at Checkout)';
      plaqueFontEl.innerHTML = '<option value="Dancing Script">Dancing Script</option><option value="Maldina Script">Maldina Script</option><option value="Garamond">Garamond</option><option value="Brittany">Brittany</option>';
      plaqueWrapEl.style.display = 'block';
      currentFeeType = 'tag';
      prefetchFee('tag');
    }

    if (hasEngravingWo) {
      engravingYesBtn.textContent = 'Yes (+$8 Added at Checkout)';
      engravingWrapEl.style.display = 'block';
      currentFeeType = 'engraving_wo';
      prefetchFee('engraving_wo');
    } else if (hasEngravingState) {
      engravingYesBtn.textContent = 'Yes (+$15 Added at Checkout)';
      engravingWrapEl.style.display = 'block';
      currentFeeType = 'engraving_state';
      prefetchFee('engraving_state');
    } else if (hasEngravingFree) {
      engravingFreeWrapEl.style.display = 'block';
    }

    var bundleNoteEl = document.getElementById('atc-popup-bundle-note');
    if (bundleNoteEl) bundleNoteEl.remove();

    if (currentProductHandle && BUNDLE_PRODUCTS[currentProductHandle]) {
      var bundleConfig = {
        'declaration-of-independence-america-the-beautiful-sign-framed-distressed-american-flag-patriotic-laser-engraved-framed-wall-art': 'America The Beautiful &amp; Framed Distressed Flag (Added at Checkout - Price Included in Bundle)',
        'patriotic-bundle': 'Framed Distressed Flag (Added at Checkout - Price Included in Bundle)',
        'declaration-of-independence-america-the-beautiful-sign-patriotic-laser-engraved-framed-wall-art': 'America The Beautiful (Added at Checkout - Price Included in Bundle)',
        'declaration-of-independence-united-states-constitution-patriotic-laser-engraved-framed-wall-art': 'United States Constitution (Added at Checkout - Price Included in Bundle)'
      };
      var bundleLabel = bundleConfig[currentProductHandle];
      if (bundleLabel) {
        var bundleNoteDiv = document.createElement('div');
        bundleNoteDiv.id = 'atc-popup-bundle-note';
        bundleNoteDiv.style.cssText = 'font-size: 15px; margin-bottom: 12px; color: #493F37;';
        bundleNoteDiv.innerHTML = '<strong>Bundled:</strong><div style="display: flex; align-items: center; gap: 8px; margin-top: 6px;"><input type="radio" checked style="width: 16px; height: 16px; pointer-events: none; cursor: default;"><span>' + bundleLabel + '</span></div>';
        submitBtn.parentNode.insertBefore(bundleNoteDiv, submitBtn);
      }
    }

    overlay.style.display = 'flex';
    document.body.style.overflow = 'hidden';
  });

  function prefetchFee(feeType) {
    fetchFeeVariantId(feeType, function() {
      var price = feePriceCache[feeType];
      if (!price) return;
      if (feeType === 'plaque') {
        plaqueYesBtn.textContent = 'Yes (+$' + price + ' Added at Checkout)';
      } else if (feeType === 'tag') {
        plaqueYesBtn.textContent = 'Yes (+$' + price + ' Added at Checkout)';
      } else if (feeType === 'engraving_wo' || feeType === 'engraving_state') {
        engravingYesBtn.textContent = 'Yes (+$' + price + ' Added at Checkout)';
      }
    });
  }

  function renderVariants(label, variants, defaultTitle, watchSmall) {
    if (variants.length === 1 && variants[0].title === 'Default Title') {
      selectedVariantId = variants[0].id;
      var html = label ? '<label class="atc-popup__label">' + label + '</label>' : '';
      html += '<div class="atc-popup__variants">';
      html += '<button type="button" class="atc-popup__variant-btn selected" data-variant-id="' + variants[0].id + '" data-variant-title="Default Title">';
      html += '$' + (parseFloat(variants[0].price) / 100).toFixed(2);
      html += '</button>';
      html += '</div>';
      optionsEl.innerHTML = html;
      return;
    }

    var html = label ? '<label class="atc-popup__label">' + label + '</label>' : '';
    html += '<div class="atc-popup__variants">';
    var defaultSet = false;
    variants.forEach(function(v) {
      var isDefault = v.title === defaultTitle;
      if (isDefault) { selectedVariantId = v.id; defaultSet = true; }
      html += '<button type="button" class="atc-popup__variant-btn' + (isDefault ? ' selected' : '') + '" data-variant-id="' + v.id + '" data-variant-title="' + v.title + '">' +
        v.title + ' - $' + (parseFloat(v.price) / 100).toFixed(2) + '</button>';
    });
    html += '</div>';
    optionsEl.innerHTML = html;

    if (!defaultSet && variants.length > 0) {
      selectedVariantId = variants[0].id;
      var firstBtn = optionsEl.querySelector('.atc-popup__variant-btn');
      firstBtn.classList.add('selected');
      if (watchSmall) checkSmall(firstBtn.dataset.variantTitle);
    } else if (defaultSet && watchSmall) {
      checkSmall(defaultTitle);
    }

    optionsEl.addEventListener('click', function(e) {
      var btn = e.target.closest('.atc-popup__variant-btn');
      if (!btn) return;
      optionsEl.querySelectorAll('.atc-popup__variant-btn').forEach(function(b) {
        b.classList.remove('selected');
      });
      btn.classList.add('selected');
      selectedVariantId = btn.dataset.variantId;
      if (watchSmall) checkSmall(btn.dataset.variantTitle);
    });
  }

  function checkSmall(variantTitle) {
    var title = variantTitle.toLowerCase();
    isSmallSelected = title === 'small' || title.startsWith('small');
    plaqueTogglesEl.style.display = isSmallSelected ? 'none' : 'flex';
    plaqueFieldsEl.style.display = isSmallSelected ? 'none' : (isPlaqueYesSelected() ? 'block' : 'none');
    plaqueSmallMsg.style.display = isSmallSelected ? 'block' : 'none';
  }

  function isPlaqueYesSelected() {
    var yesBtn = plaqueTogglesEl.querySelector('[data-value="yes"]');
    return yesBtn && yesBtn.classList.contains('selected');
  }

  plaqueTogglesEl.addEventListener('click', function(e) {
    var btn = e.target.closest('.atc-popup__toggle-btn');
    if (!btn) return;
    setToggleActive(plaqueTogglesEl, btn);
    plaqueFieldsEl.style.display = btn.dataset.value === 'yes' ? 'block' : 'none';
  });

  engravingTogglesEl.addEventListener('click', function(e) {
    var btn = e.target.closest('.atc-popup__toggle-btn');
    if (!btn) return;
    setToggleActive(engravingTogglesEl, btn);
    engravingFieldsEl.style.display = btn.dataset.value === 'yes' ? 'block' : 'none';
  });

  function setToggleActive(container, activeBtn) {
    container.querySelectorAll('.atc-popup__toggle-btn').forEach(function(b) {
      b.classList.remove('selected');
    });
    activeBtn.classList.add('selected');
  }

  function resetToggle(container) {
    var btns = container.querySelectorAll('.atc-popup__toggle-btn');
    btns.forEach(function(b) { b.classList.remove('selected'); });
    if (btns.length > 0) btns[0].classList.add('selected');
  }

  submitBtn.addEventListener('click', function() {
    if (!selectedVariantId) {
      messageEl.textContent = 'Please select an option.';
      return;
    }

    var properties = {};

    if (templeFieldEl.style.display !== 'none' && templeInput.value.trim()) {
      properties['Temple Name'] = templeInput.value.trim();
    }

    var plaqueYes = !isSmallSelected && isPlaqueYesSelected() && plaqueWrapEl.style.display !== 'none';
    var isTag = currentTags.includes('has-tag');

    if (plaqueYes) {
      var prefix = isTag ? 'Tag' : 'Plaque';
      var price = feePriceCache[currentFeeType] || (isTag ? '11.00' : '15.00');
      properties[prefix + ' Color'] = plaqueColorEl.value;
      properties[prefix + ' Font'] = plaqueFontEl.value;
      properties[prefix + ' Inscription'] = plaqueTextEl.value.trim();
      properties['Personalized ' + prefix] = 'Yes (+$' + price + ' Added at Checkout)';
    }

    var engravingYesBtn = engravingTogglesEl.querySelector('[data-value="yes"]');
    var engravingYes = engravingYesBtn && engravingYesBtn.classList.contains('selected') && engravingWrapEl.style.display !== 'none';

    if (engravingYes) {
      var engravingPrice = feePriceCache[currentFeeType] || (currentFeeType === 'engraving_wo' ? '8.00' : '15.00');
      properties['Engraving'] = 'Yes (+$' + engravingPrice + ' Added at Checkout)';
      properties['Engraving Text'] = engravingTextEl.value.trim();
    }

    var freeEngravingText = engravingFreeTextEl.value.trim();
    if (engravingFreeWrapEl.style.display !== 'none' && freeEngravingText) {
      properties['Engraving Text'] = freeEngravingText;
    }

    var itemsToAdd = [{ id: parseInt(selectedVariantId), quantity: 1, properties: properties }];
    var needsFee = (plaqueYes && currentFeeType) || (engravingYes && currentFeeType);

    var bundleHandles = currentProductHandle && BUNDLE_PRODUCTS[currentProductHandle] ? BUNDLE_PRODUCTS[currentProductHandle] : [];
    var bundleItems = bundleHandles.map(function(handle) {
      var variantId = bundleVariantCache[handle];
      if (!variantId) return null;
      return { id: variantId, quantity: 1, properties: { '_bundle_item': 'true', '_bundle_parent': currentProductHandle } };
    }).filter(function(item) { return item !== null; });

    itemsToAdd = itemsToAdd.concat(bundleItems);

    submitBtn.disabled = true;
    messageEl.textContent = 'Adding...';

    function doCartAdd(items) {
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      })
      .then(function(r) { return r.json(); })
      .then(function() {
        messageEl.textContent = 'Added to cart!';
        submitBtn.disabled = false;
        fetch('/cart.js')
          .then(function(r) { return r.json(); })
          .then(function(cart) {
            document.querySelectorAll('.cart-count, [data-cart-count], .js-cart-count').forEach(function(el) {
              el.textContent = cart.item_count;
            });
          });
        setTimeout(function() {
          closePopup();
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
          document.dispatchEvent(new CustomEvent('custom-atc:added'));
          if (typeof theme !== 'undefined' && theme.cart) {
            theme.cart.getCart();
          }
          var cartDrawerTrigger = document.querySelector('.js-drawer-open-cart, .js-cart-open, [data-cart-toggle]');
          if (cartDrawerTrigger) cartDrawerTrigger.click();
        }, 800);
      })
      .catch(function() {
        messageEl.textContent = 'Something went wrong. Please try again.';
        submitBtn.disabled = false;
      });
    }

    if (needsFee) {
      fetchFeeVariantId(currentFeeType, function(feeVariantId) {
        if (feeVariantId) {
          itemsToAdd.push({ id: feeVariantId, quantity: 1, properties: {} });
        }
        doCartAdd(itemsToAdd);
      });
    } else {
      doCartAdd(itemsToAdd);
    }
  });

  closeBtn.addEventListener('click', closePopup);
  overlay.addEventListener('click', function(e) {
    if (e.target === overlay) closePopup();
  });
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') closePopup();
  });

  function closePopup() {
    overlay.style.display = 'none';
    document.body.style.overflow = '';
    selectedVariantId = null;
    messageEl.textContent = '';
  }
})();